let currentObservers = [];

export function refresh() {
  currentObservers.map(observer => observer.disconnect());
  startListening();
}

export function startListening() {
  var target = document.querySelectorAll('[data-aos]');

  var callback = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('aos-animate');
      } else {
        entry.target.classList.remove('aos-animate');
      }
    });
  };

  currentObservers = Array.from(target).map(element => {
    element.classList.add('aos-init');
    if (!element.getAttribute('data-aos-duration')) {
      element.setAttribute('data-aos-duration', '500');
    }
    const currentObserver = new IntersectionObserver(callback, { threshold: 0 });
    currentObserver.observe(element);
    return currentObserver;
  })
}

export default function initAos() {
  startListening();

  document.body.addEventListener('onseeing-content-update', () => {
    refresh();
  });
}
